// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"_1zWy1","titleWrapper":"_2VaPq"};